var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-compass compass",on:{"click":_vm.onCompassClick}},[_c('svg-icon',{staticClass:"compass__inner",style:({'transform': 'rotate(' + _vm.value + 'deg)'}),attrs:{"original":"","name":"icons/compass-off"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }